import styled from 'styled-components'

export const QuoteOuter = styled.section`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  padding: ${({ pad }) => pad || '0 1.8rem'};

  @media only screen and (max-width: 500px) {
    padding: ${({ mobilePad }) => mobilePad};
  }
`

export const QuoteWrapper = styled.div`
  max-width: 1083px;
  padding: 0 0 2.4rem;
  > p {
    font-size: 35px;
    font-weight: 600;
    font-style: normal;
    letter-spacing: normal;
    line-height: 1.3;
    text-align: center;
    @media only screen and (max-width: 1200px) {
      font-size: 30px;
    }
    @media only screen and (max-width: 700px) {
      font-size: 24px;
    }
  }
`

export const NameWrapper = styled.div`
  display: flex;
`

export const AvatarWrapper = styled.div`
  height: 81px;
  width: 81px;
  padding-right: 27px;
  > div {
    border: 1px solid #979797;
    border-radius: 50%;
  }
`

export const TextWrapper = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  font-size: 18px;
  .head {
    color: ${({ theme }) => theme.colors.primary};
    letter-spacing: 0.12px;
  }

  .sub {
    font-weight: 300;
    font-size: 18px;
  }
`
